module.exports = __webpack_public_path__ + "img/wp-new-habit-card8.324f0fc0.jpg";